<div id="filter">
  <div class="container-fluid">
    <div class="row">
      <div class="col no-pad">
        <div class="search">
          <input
            type="text"
            placeholder="Pesquisar"
            [(ngModel)]="search"
            (keyup.enter)="addFilterSearch()"
          />

          <span class="icn-search" (click)="addFilterSearch()"></span>
        </div>
      </div>

      <div
        class="col no-pad"
        *ngIf="
          typeComponent == 'service-order-management' ||
          typeComponent == 'invoice'
        "
      ></div>

      <div
        class="col no-pad text-align-right"
        *ngIf="
          typeComponent != 'service-order-management' &&
          typeComponent != 'invoice' &&
          typeComponent != 'reports'
        "
      >
        <div
          class="filters"
          filterMenu
          (outsideFilterMenu)="openFilterMenu($event)"
          *ngIf="typeComponent != 'supervisor'"
        >
          <button class="icn-filter" (click)="openFilterMenu(true)">
            Filtros
          </button>

          <div *ngIf="filterMenu" class="hidden">
            <h6>Filtrar por:</h6>

            <div class="combo" *ngIf="typeComponent == 'services'">
              <h5>EQUIPAMENTO</h5>

              <div class="values">
                <select [(ngModel)]="equipments">
                  <option value="">Selecione</option>
                  <option
                    *ngFor="let equipment of equipmentsArr"
                    [value]="equipment.cdProduto"
                    >{{ equipment.dsProduto }}</option
                  >
                </select>
              </div>
            </div>

            <div class="combo" *ngIf="typeComponent == 'service-providers'">
              <h5>REGIÃO</h5>

              <div class="values">
                <select [(ngModel)]="regions">
                  <option value="">Selecione</option>
                  <option
                    *ngFor="let region of regionsArr"
                    [value]="region.cdRegiao"
                    >{{ region.dsRegiao }}</option
                  >
                </select>
              </div>
            </div>

            <div class="combo" *ngIf="typeComponent == 'service-providers'">
              <h5>TIPO DE SERVIÇO</h5>

              <div class="values">
                <select [(ngModel)]="services">
                  <option value="">Selecione</option>
                  <option
                    *ngFor="let service of servicesArr"
                    [value]="service.cdTpServico"
                    >{{ service.dsTpServico }}</option
                  >
                </select>
              </div>
            </div>

            <div class="combo" *ngIf="typeComponent == 'services'">
              <h5>PRESTADOR DE SERVIÇO</h5>

              <div class="values">
                <select [(ngModel)]="providers">
                  <option value="">Selecione</option>
                  <option
                    *ngFor="let provider of providersArr"
                    [value]="provider.cdFornecedor"
                    >{{ provider.nmFantasia }}</option
                  >
                </select>
              </div>
            </div>

            <div class="combo" *ngIf="typeComponent == 'service-order'">
              <h5>STATUS</h5>

              <div class="values">
                <select [(ngModel)]="status">
                  <option value="">Selecione</option>
                  <option
                    *ngFor="let status of statusArr"
                    [value]="status.cdStatusRequisicao"
                    >{{ status.dsStatusRequisicao }}</option
                  >
                </select>
              </div>
            </div>

            <div class="combo" *ngIf="typeComponent == 'service-order'">
              <h5>LOJA (Nº DA LOJA)</h5>

              <input
                type="text"
                placeholder="Nº da loja"
                [(ngModel)]="stores"
              />
            </div>

            <div class="combo" *ngIf="typeComponent == 'service-order'">
              <h5>Nº DO PEDIDO</h5>

              <input
                type="text"
                placeholder="Nº do pedido"
                [(ngModel)]="orders"
              />
            </div>

            <div
              class="combo"
              *ngIf="
                typeComponent != 'service-providers' &&
                typeComponent != 'service-order'
              "
            >
              <h5>VALOR</h5>

              <div class="values">
                <input
                  type="text"
                  placeholder="de"
                  [(ngModel)]="de"
                  #deInp
                  currencyMask
                />

                <input
                  type="text"
                  placeholder="até"
                  [(ngModel)]="ate"
                  #ateInp
                  currencyMask
                />
              </div>

              <button
                class="icn-filter"
                (click)="
                  addFilterValues(
                    'De: ' + deInp.value + ' até ' + ateInp.value
                  );
                  addFilterStrings()
                "
              >
                Filtrar
              </button>
            </div>

            <div
              *ngIf="
                typeComponent != 'equipments' &&
                typeComponent != 'services' &&
                typeComponent != 'supervisor'
              "
            >
              <button class="icn-filter" (click)="addFilterStrings()">
                Filtrar
              </button>
            </div>
          </div>
        </div>

        <button class="btn-green icn-add" [routerLink]="urlBtnNew">
          {{ textBtnNew }}
        </button>
      </div>

      <div
        class="col col-lg-8 col-xl-6 no-pad text-align-right"
        *ngIf="typeComponent == 'reports'"
      >
        <button class="btn-export icn-printer">Imprimir</button>

        <button class="btn-export icn-excel">Exportar em Excel</button>

        <button class="btn-export icn-pdf">Exportar em PDF</button>
      </div>
    </div>

    <div
      class="row other-filters"
      [class.hide]="!otherFilters"
      *ngIf="typeComponent == 'reports'"
    >
      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>DATA INICIAL DE ABERTURA</h5>

        <input
          type="text"
          class="text-align-center"
          angular-mydatepicker
          [(ngModel)]="dateFirst"
          [options]="datePickerOptions"
          #datePickerFirst="angular-mydatepicker"
          (click)="datePickerFirst.toggleCalendar()"
          (dateChanged)="dateFirstChanged($event)"
        />
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>DATA FINAL DE ABERTURA</h5>

        <input
          type="text"
          class="text-align-center"
          angular-mydatepicker
          [(ngModel)]="dateLast"
          [options]="datePickerOptions"
          #datePickerLast="angular-mydatepicker"
          (click)="datePickerLast.toggleCalendar()"
          (dateChanged)="dateLastChanged($event)"
        />
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>Nº DO PEDIDO</h5>

        <input type="text" [(ngModel)]="orders" />
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>ID DA OS</h5>

        <input type="text" [(ngModel)]="serviceorders" />
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>Nº DA LOJA</h5>

        <input type="text" [(ngModel)]="stores" />
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>BANDEIRA</h5>

        <select [(ngModel)]="flags">
          <option value="">Selecione</option>
          <option *ngFor="let flag of flagsArr" [value]="flag.cdLogomarca">{{
            flag.dsLogomarca
          }}</option>
        </select>
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>REGIÃO</h5>

        <select [(ngModel)]="regions">
          <option value="">Selecione</option>
          <option *ngFor="let region of regionsArr" [value]="region.cdRegiao">{{
            region.dsRegiao
          }}</option>
        </select>
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>PRESTADOR DE S.</h5>

        <select [(ngModel)]="providers">
          <option value="">Selecione</option>
          <option
            *ngFor="let provider of providersArr"
            [value]="provider.cdFornecedor"
            >{{ provider.nmFantasia }}</option
          >
        </select>
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>EQUIPAMENTO</h5>

        <select [(ngModel)]="equipments">
          <option value="">Selecione</option>
          <option
            *ngFor="let equipment of equipmentsArr"
            [value]="equipment.cdProduto"
            >{{ equipment.dsProduto }}</option
          >
        </select>
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>STATUS</h5>

        <select [(ngModel)]="status">
          <option value="">Selecione</option>
          <option
            *ngFor="let status of statusArr"
            [value]="status.cdStatusRequisicao"
            >{{ status.dsStatusRequisicao }}</option
          >
        </select>
      </div>

      <div class="col no-pad col-xl-2 col-lg-4">
        <h5>NOME DO FILTRO</h5>

        <app-autocomplete
          [placeHolder]="placeHolder"
          [notFoundText]="notFoundText"
          [searchKeyword]="searchKeywordFilter"
          [data]="autocompleteDataFilter"
          (selected)="onSelectFilter($event)"
          (keyuped)="showSaveFilterBtn($event)"
          [itemTemplate]="templateFilter"
          [notFoundTemplate]="notFoundFilter"
          #autocompleteFilter
        >
        </app-autocomplete>

        <ng-template #templateFilter let-item>
          <a [innerHTML]="item.dsFiltro"></a>
        </ng-template>

        <ng-template #notFoundFilter let-notFound>
          <div [innerHTML]="notFound"></div>
        </ng-template>
      </div>

      <div class="col no-pad col-xl-2 col-lg-4 text-align-center">
        <h5>&nbsp;</h5>

        <button
          class="btn-green"
          (click)="addFilterStrings()"
          *ngIf="!saveFilterBtn"
        >
          {{ textBtnFilter }}
        </button>

        <button class="btn-green" (click)="saveFilter()" *ngIf="saveFilterBtn">
          Salvar Filtro
        </button>
      </div>
    </div>

    <div class="row" *ngIf="typeComponent == 'reports'">
      <div class="col no-pad col-xl-12">
        <div class="toggle_other-filters">
          <div class="line" [class.colapse]="colapseLine"></div>

          <span (click)="toggleOtherFilters()">{{ textLineFilter }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col no-pad">
        <div class="filters-selected">
          <ul>
            <li *ngFor="let val of filtersText">
              {{ val.string }}
              <span
                class="icn-close"
                (click)="removeFilter(val.string, val.type)"
              ></span>
            </li>
            <li *ngIf="filtersText.length > 0">
              <button (click)="resetFilters(true)">Limpar Filtros</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
